var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5H2.5C2.16848 5 1.85054 5.1317 1.61612 5.36612C1.3817 5.60054 1.25 5.91848 1.25 6.25V8.75C1.25 9.08152 1.3817 9.39946 1.61612 9.63388C1.85054 9.8683 2.16848 10 2.5 10H3.125V12.5C3.125 12.6658 3.19085 12.8247 3.30806 12.9419C3.42527 13.0592 3.58424 13.125 3.75 13.125H5C5.16576 13.125 5.32473 13.0592 5.44194 12.9419C5.55915 12.8247 5.625 12.6658 5.625 12.5V10H7.5L10.625 12.5V2.5L7.5 5ZM13.4375 7.5C13.4375 8.56875 12.8375 9.5375 11.875 10V5C12.8313 5.46875 13.4375 6.4375 13.4375 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.76c7e2465340ba16fa681cfb8de33db9.svg";
export { ForwardRef as ReactComponent };